<!--suppress ALL -->
<template>
  <g-field :label="label" :type="type" :message="message">
    <g-field is-grouped>
      <g-select @change="onSelected" is-fullwidth :value="merchant || ''"
                :placeholder="merchants.length === 0 ? $t('text.no_content_loaded') :
                `${placeholder}`" class="control is-expanded">
        <option v-for="merchant in merchants"
                :value="merchant.nama" :key="merchant.kode">
          {{ merchant.nama }}
        </option>
      </g-select>

      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </g-field>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'annotation';
import {cloneDeep} from 'lodash';
import Store from "../../../util/Store";
import Merchant from "../../../entity/Merchant";

@Component
export default class MerchantSelect extends Vue {

  @Prop({default: "", type: String})
  public merchant: string;

  @Prop({default: "Kantin", type: String})
  public label: string;

  @Prop({default: "Pilih kantin", type: String})
  public placeholder: string;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  public isLoading: boolean = false;

  public get merchants() {
    let merchants: Array<Merchant> = Store.getVmProperty('merchant.data', []);
    return merchants;
  }

  public created() {
    Store.dispatchMerchant(true);
  }

  public onSelected(kode: string) {
    const merchant: Merchant = this.merchants.find((item: Merchant) => item.kode === kode) ||
        new Merchant();

    this.$emit('merchant-selected', cloneDeep(merchant));
  }

}
</script>
